<template>
    <el-container style="width:100%">
        <el-header>
            <el-form :inline="true" :model="formUser" ref="formUser" class="demo-form-inline">
                <el-row>
                    <td-permission :permissions="permissionsView">
                        <div slot="havePermission">
                            <el-form-item :label="$t('common.USERNAME')" prop="userName">
                                <td-input v-model="formUser.userName"></td-input>
                            </el-form-item>
                            <el-form-item :label="$t('common.LOCK_STATE')" prop="locked">
                                <td-select v-model="formUser.locked" :options="options"></td-select>
                            </el-form-item>
                        </div>
                    </td-permission>
                    <el-form-item class="menuStyle">
                        <td-button @click="btnQuery" :permissions="permissionsView" :loading="loading" type="primary">{{ $t('common.QUERY') }}</td-button>
                        <td-button @click="btnSync" :permissions="permissionsAdd" :loading="syncLoading">{{ $t('common.SYNCHRONIZE') }}</td-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :dataSource="tableData"
                :permissions="permissionsView"
                :columns="columns"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                :hasIndex="hasIndex"
                :hasMutiSelect="hasMutiSelect"
                :hasPage="hasPage"
                :rowKey="rowKey"
                :hasLoading="hasLoading"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-User
                v-if="dialogUserVisible"
                :isAddData="isAddData"
                :dialogUserVisible="dialogUserVisible"
                :editItem="editItem"
                :title="title"
                :selectOptions="selectOptions"
                @userDialogClose="userDialogClose"
                @btnQuery="btnQuery"
            ></dialog-User>
        </el-main>
    </el-container>
</template>
<script>
import api from './assets/api.js';
import dialogMenu from './components/dialogUser.vue';
export default {
    components: {
        'dialog-User': dialogMenu
    },
    data() {
        return {
            formUser: {
                userName: '',
                locked: ''
            },
            permissionsAdd: ['workflow:add'],
            permissionsEdit: ['workflow:edit'],
            permissionsView: ['workflow:view'],
            permissionsDel: ['workflow:del'],
            hasIndex: true,
            rowKey: 'userId',
            hasMutiSelect: false,
            hasPage: true,
            loading: false,
            syncLoading: false,
            isAddData: false,
            dialogUserVisible: false,
            title: '',
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            hasLoading: false,
            selectOptions: [],
            columns: [
                {
                    label: 'common.USERNAME',
                    prop: 'userName',
                    align: 'center'
                },
                {
                    label: 'common.LOCK_STATE',
                    prop: 'locked',
                    align: 'center',
                    render: (createElement, params) => {
                        if (params.row.locked === this.$common.userLockState.LOCKED) {
                            return createElement('span', this.$t('common.LOCKED'));
                        }
                        return createElement('span', this.$t('common.NOT_LOCKED'));
                    }
                },
                {
                    label: 'common.OPERATE',
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsView, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnExit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            )
                        ]);
                    }
                }
            ],
            tableData: [],
            // 对表单进行数据验证
            rules: {
                userName: [
                    {
                        pattern: this.$regex.ROLECAPTION_RULE,
                        message: this.$t('error.ERROR_USER_CAPTION_ILLEGAL')
                    }
                ]
            },
            // 锁定状态下拉列表
            options: [
                {
                    value: '1',
                    label: this.$t('common.LOCKED')
                },
                {
                    value: '0',
                    label: this.$t('common.NOT_LOCKED')
                }
            ]
        };
    },
    mounted() {
        this.btnQuery();
    },
    methods: {
        btnSync() {
            this.syncLoading = true;
            this.$confirm(this.$t('common.OPERATION_WARING'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    api.syncUserAndRoleInfo({}, response => {
                        if (response.status !== this.$common.login.RESPONSE_STATUS) {
                            this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                            this.syncLoading = false;
                            this.$log.error('workFlowAuthor/syncUserAndRoleInfo', response);
                            return;
                        }
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                            this.$log.error('workFlowAuthor/syncUserAndRoleInfo', response.data.message);
                            this.syncLoading = false;
                        } else {
                            this.$message({ type: 'success', showClose: true, message: response.data.statusMessage });
                            this.syncLoading = false;
                            this.btnQuery();
                        }
                    });
                })
                .catch(() => {
                    this.syncLoading = false;
                    this.$log.error('org/onClickDelete---- Fail');
                });
        },
        /* 用户信息编辑 */
        btnExit(row) {
            this.editItem = row;
            this.title = 'common.EDIT';
            this.isAddData = false;
            this.dialogUserVisible = true;
        },
        /* 用户信息查询 */
        btnQuery() {
            this.loading = true;
            this.currentPage = 1;
            this.queryList();
        },
        queryList() {
            let param = {
                userName: this.formUser.userName,
                locked: this.formUser.locked,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            };
            api.listUserInfo(param, response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    this.$log.error('workFlowAuthor/listUserInfo', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('workFlowAuthor/listUserInfo', response.data.message);
                    this.loading = false;
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        userDialogClose() {
            this.dialogUserVisible = false;
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.queryList();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.queryList();
        }
    }
};
</script>
<style>
.menuStyle {
    padding-left: 100px;
}
</style>
